// Kabul İşlemleri ve Fiyat Ver ekranları ortak kullanır.
export const paraFormat = (sayi) => sayi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// B.Fiyat hesabı — kullanıcının VB6 uygulamasındaki mantığın birebir karşılığı (kullanıcı talebi: 2026-08-08).
//
// Hizmet (TTB) kaynağı: DAT = tarifenin FYT_KOD'u. DAT 1-20 arasıysa TTB.F1-F20'den ilgili sütun
// FIAT olarak okunur (DAT=0 veya aralık dışıysa FIAT=0). Sonra 2 adımda düzeltilir:
//  1) Tarifenin YZD (yüzde) farkı YUK_AS'a göre eklenir (YUK_AS=1) ya da çıkarılır (diğer her değer).
//  2) FATAYAR=2 ise KDV dahil fiyattan KDV'siz fiyata çevrilir: FIAT = (100*FIAT)/(100+KDVYD).
//
// Stok (TTB_STOK) kaynağı: FIAT doğrudan TTB_STOK.FIAT'tan alınır, tarife yüzdesi (1. adım) hiç
// uygulanmaz — sadece FATAYAR=2 ise aynı KDV ayrıştırma adımı uygulanır (kullanıcı talebi: 2026-08-09).
//
// Paket kalemleri (PAKETHZMT): fytTp1=1 ise birim fiyat sabittir, doğrudan fiat1 kullanılır — hizmet/
// stok formülleri hiç çalışmaz, KDV adımı da uygulanmaz. fytTp1=0 (veya paketten gelmemişse hiç yoksa)
// yukarıdaki normal hizmet/stok formülü aynen işler (kullanıcı talebi: 2026-08-09).
//
// Bağlı nesneler (TTB_STOK_BAGLA): ozelFiat=1 ise başlangıç fiyatı sabit fiat1'dir (DAT/tarife formülü
// ATLANIR) — AMA fytTp1'in aksine KDV adımı yine de altındaki TTB/TTB_STOK'un kendi FATAYAR/KDVYD'sine
// göre uygulanır. ozelFiat=0 (veya bağlı nesneden gelmemişse) normal hizmet/stok formülü işler
// (kullanıcı talebi: 2026-08-09).
export const hesaplaBirimFiyat = (kayit, tarife) => {
  if (kayit.fytTp1 === 1) return Number(kayit.fiat1) || 0;

  let fiat;

  if (kayit.ozelFiat === 1) {
    fiat = Number(kayit.fiat1) || 0;
  } else if (kayit.kaynak === 'stok') {
    fiat = Number(kayit.fiat) || 0;
  } else if (!tarife) {
    fiat = 0;
  } else {
    const dat = tarife.fytKod || 0;
    fiat = (dat >= 1 && dat <= 20) ? Number(kayit[`f${dat}`]) || 0 : 0;

    const yzd = tarife.yzd || 0;
    const degs1 = (fiat / 100) * yzd;
    fiat = tarife.yukAs === 1 ? fiat + degs1 : fiat - degs1;
  }

  if (kayit.fatAyar === 2) {
    const kdvYd = Number(kayit.kdvYd) || 0;
    fiat = (100 * fiat) / (100 + kdvYd);
  }

  return fiat;
};

// TOPLAM/KDV/G.TOPLAM kümülatifleri — Kabul İşlemleri ve Fiyat Ver ortak kullanır (kullanıcı talebi:
// 2026-08-09). satirlar: [{ birimFiyat, kdvYd }].
// TOPLAM = B.Fiyat hücrelerinin toplamı (adet çarpılmaz). Her satırın KDV katkısı = B.Fiyat * kdvYd/100,
// bu katkılar kendi kdvYd yüzdelerine göre gruplanıp toplanır (çoğu zaman tek grup — ör. hepsi %10 — ama
// nadiren farklı yüzdeler karışırsa birden fazla "KDV %X" satırı oluşur). G.TOPLAM = TOPLAM + tüm KDV
// gruplarının toplamı.
export const hesaplaKumulatif = (satirlar) => {
  const toplam = satirlar.reduce((acc, s) => acc + (Number(s.birimFiyat) || 0), 0);

  const gruplar = {};
  satirlar.forEach(s => {
    const yuzde = Number(s.kdvYd) || 0;
    const katki = (Number(s.birimFiyat) || 0) * (yuzde / 100);
    gruplar[yuzde] = (gruplar[yuzde] || 0) + katki;
  });

  const kdvGruplari = Object.entries(gruplar)
    .map(([yuzde, tutar]) => ({ yuzde: Number(yuzde), tutar }))
    .sort((a, b) => a.yuzde - b.yuzde);

  const kdvToplam = kdvGruplari.reduce((acc, g) => acc + g.tutar, 0);

  return { toplam, kdvGruplari, gToplam: toplam + kdvToplam };
};
